import React from 'react'

import './Skeleton.css'

export const SkeletonRow = () => (
  <tr>
    <td>
      <div className="skeleton" style={{ width: '120px', height: '1em' }} />
    </td>
    <td className="d-none d-md-table-cell">
      <div className="skeleton" style={{ width: '140px', height: '1em' }} />
    </td>
    <td className="d-none d-xl-table-cell">
      <div className="skeleton" style={{ width: '140px', height: '1em' }} />
    </td>
    <td className="d-none d-sm-table-cell">
      <div className="skeleton" style={{ width: '90px', height: '1em' }} />
    </td>
    <td className="d-none d-lg-table-cell">
      <div className="skeleton" style={{ width: '100px', height: '1em' }} />
    </td>
    <td>
      <div className="skeleton" style={{ width: '90px', height: '1em' }} />
    </td>
    <td className="d-none d-sm-table-cell">
      <div className="skeleton" style={{ width: '130px', height: '1.4em', borderRadius: '999px' }} />
    </td>
    <td className="d-none d-lg-table-cell">
      <div className="skeleton" style={{ width: '90px', height: '1em' }} />
    </td>
  </tr>
)
